module.exports = __webpack_public_path__ + "static/media/placeholder-avatar.0ff49a61.svg";